import { context } from '@wikia/ad-engine';

export function getRubiconDisplayContext(): object {
	const midBoxAdConfigs = context.get('options.replaceOpenWebWithMidBoxAd')
		? {
				mid_boxad: {
					sizes: [[300, 250]],
					targeting: {
						loc: ['middle'],
					},
					siteId: '500662',
					zoneId: '3616766',
				},
			}
		: {};

	return {
		enabled: false,
		accountId: 7450,
		slots: {
			top_leaderboard: {
				sizes: [
					[728, 90],
					[970, 250],
				],
				targeting: {
					loc: ['top'],
				},
				position: 'atf',
				siteId: '148804',
				zoneId: '704672',
			},
			top_boxad: {
				sizes: [
					[300, 250],
					[300, 600],
				],
				targeting: {
					loc: ['top'],
				},
				position: 'atf',
				siteId: '148804',
				zoneId: '704672',
			},
			...midBoxAdConfigs,
			incontent_boxad: {
				sizes: [
					[160, 600],
					[300, 600],
					[300, 250],
					[300, 1050],
				],
				targeting: {
					loc: ['hivi'],
				},
				siteId: '148804',
				zoneId: '704676',
			},
			bottom_leaderboard: {
				sizes: [
					[728, 90],
					[970, 250],
				],
				targeting: {
					loc: ['footer'],
				},
				siteId: '148804',
				zoneId: '704674',
			},
			fandom_dt_galleries: {
				sizes: [[728, 90]],
				siteId: '494482',
				zoneId: '2942280',
				targeting: {
					loc: ['gallery'],
				},
			},
		},
	};
}
